import { winterData } from '../lib/data';
import styles from './Winter.module.scss';


const Winter = () => {
        return ( 
        <section >
            <div className = {styles.container}>          
                {winterData.map(({id, photo}) => (
                    <div className = {styles.container__photo} key={id}> 
                    <img  className={styles.photo} src={photo} alt="зимняя фотосессия Ставрополь"/>
                    </div>
                ))}
            </div>
        </section>
    );
}
export default Winter;